import { useEffect } from 'react';
import { supabase } from '@/lib/supabase';

const SESSION_KEY = 'fc_view_counted';

/**
 * Increments the site-wide view counter once per browser session.
 */
export function useViewCounter() {
  useEffect(() => {
    const counted = sessionStorage.getItem(SESSION_KEY);
    if (counted) return;

    const increment = async () => {
      try {
        const { data } = await supabase
          .from('site_stats')
          .select('views')
          .eq('id', 1)
          .maybeSingle();

        const current = data?.views ?? 0;
        await supabase
          .from('site_stats')
          .update({ views: current + 1, updated_at: new Date().toISOString() })
          .eq('id', 1);
        sessionStorage.setItem(SESSION_KEY, '1');
      } catch (err) {
        // Silent fail for view counter
      }
    };

    increment();
  }, []);
}